
$('.slider-nav.mobile').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrow: true,
  focusOnSelect: true,
  infinite: false, 
  variableWidth: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 490, 
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});